<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a
        routerLink="/button"
        aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto"
        role="button"
      >
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div
      class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left"
    >
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Stepper without route
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<maced-stepper
  id="stepperId2"
  [hasStepperLabel]="true"
  [stepperTitle]="stepperTitle"
  [stepperItems]="stepperItems"
  [currentStep]="currentStep"
  [mobileViewLabel]="mobileViewLabel"
  [hasClickEvent]="false"
>
  <div class="row" *ngIf="currentStep === 0">
    <app-stepone></app-stepone>
  </div>
  <div class="row" *ngIf="currentStep === 1">
    <app-steptwo></app-steptwo>
  </div>
  <div class="row" *ngIf="currentStep === 2">
    <app-stepfinal></app-stepfinal>
  </div>
</maced-stepper>

<maced-stepper
  id="stepperId22"
  [stepperTitle]="stepperTitleSpanish"
  [stepperItems]="stepperItemsSpanish"
  [currentStep]="currentStepSpanish"
  [mobileViewLabel]="mobileViewLabelSpanish"
>
  <div class="row" *ngIf="currentStepSpanish === 0">
    <app-stepone></app-stepone>
  </div>
  <div class="row" *ngIf="currentStepSpanish === 1">
    <app-steptwo></app-steptwo>
  </div>
  <div class="row" *ngIf="currentStepSpanish === 2">
    <app-stepfinal></app-stepfinal>
  </div>
</maced-stepper>

<maced-stepper
  id="stepperId222"
  [stepperTitle]="stepperTitleHindi"
  [stepperItems]="stepperItemsHindi"
  [currentStep]="currentStepHindi"
  [mobileViewLabel]="mobileViewLabelHindi"
>
  <div class="row" *ngIf="currentStepHindi === 0">
    <app-stepone></app-stepone>
  </div>
  <div class="row" *ngIf="currentStepHindi === 1">
    <app-steptwo></app-steptwo>
  </div>
  <div class="row" *ngIf="currentStepHindi === 2">
    <app-stepfinal></app-stepfinal>
  </div>
</maced-stepper>

<br />
<div class="align-center"><a routerLink="/stepperroute" class="u-button u-mb-20">GOTO Stepper with route</a></div>

